export default {

    // 三基同创 测试 test文件夹

    language: '',


    // 支付相关 
    productList: [],
    status: false,
    bindStatus: false, // 当前设备是否绑卡操作


    channelId: '51dfc6de7a32ee6a ',

    uid: "",
    clientSecret: "",
    customerId: "",
    email: "",
    firstName: "",
    lastName: "",
    noticeList: [],
    subProduct: [],
    // zhzn 支付展示类型
    product: 3,

    // 支付接口前缀
    apiUrl: "",

    // 齐沃相关参数 token
    token: "",
    appid: "",

    // xtc相关参数（当前邮箱绑定态也复用该值）
    appuuid: "",

}
